import ConversationMessageRecord from "models/view-models/conversations/conversation-message-record";
import { Thunk } from "utilities/atoms/atom-with-thunks-reducer";
import {
    ConversationsAction,
    CurrentConversationState,
} from "./conversation-atom.reducer";
import { sendMessage } from "./send-message.thunk";
import { MessageRole } from "models/enumerations/conversations/message-role";

interface RetryThunkParams {
    message: ConversationMessageRecord;
}

/**
 * Regenerates a response for a given message. Finds the user message that prompted the response and
 * resends it. All messages between the user message and the response (inclusive) are removed.
 */
export const retry =
    ({
        message,
    }: RetryThunkParams): Thunk<
        CurrentConversationState,
        ConversationsAction
    > =>
    async (dispatch, getState) => {
        const { parent: userMessage, childIds } = findUserParentMessage(
            message.parentId,
            getState()
        );
        if (!userMessage?.content) return;
        if (message.id) childIds.add(message.id);

        dispatch({ type: "RETRY", ids: Array.from(childIds) });
        sendMessage({
            prompt: userMessage.content,
            messageId: userMessage.id,
        })(dispatch, getState);
    };

function findUserParentMessage(
    parentId: string | undefined,
    state: CurrentConversationState,
    childIds: Set<string> = new Set()
): { parent: ConversationMessageRecord | undefined; childIds: Set<string> } {
    if (!parentId || !state.currentConversation?.messages)
        return { parent: undefined, childIds };

    const parent = state.currentConversation.messages.find(
        (m) => m.id === parentId
    );
    if (!parent) return { parent: undefined, childIds };
    if (parent.role === MessageRole.User) return { parent, childIds };
    if (parent.id) childIds.add(parent.id);
    return findUserParentMessage(parent.parentId, state, childIds);
}
